import artifact from '$houdini/artifacts/UpdateUserAccount'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateUserAccountStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
